<ion-grid class="wrapper">
  <ion-row>
    <ion-col size="1"></ion-col>
    <ion-col size="7">
      Inventory Name
      @if (sortBy==='name' && sortDirection==='asc') {
      <ion-icon name="caret-down-circle-outline"></ion-icon>
      }
      @if (sortBy==='name' && sortDirection==='desc') {
      <ion-icon name="caret-up-circle-outline"></ion-icon>
      }
    </ion-col>
    <ion-col size="2">
      <p>OH</p>
      <p>PL</p>
      @if (sortBy==='routePar' && sortDirection==='asc') {
      <ion-icon name="caret-down-circle-outline"></ion-icon>
      }
      @if (sortBy==='routePar' && sortDirection==='desc') {
      <ion-icon name="caret-up-circle-outline"></ion-icon>
      }
    </ion-col>
    <ion-col size="2">
      D
      @if (sortBy==='routePar' && sortDirection==='asc') {
      <ion-icon name="caret-down-circle-outline"></ion-icon>
      }
      @if (sortBy==='routePar' && sortDirection==='desc') {
      <ion-icon name="caret-up-circle-outline"></ion-icon>
      }
    </ion-col>
  </ion-row>
  @for (item of inventory; track item) {
  <ion-row class="data-grid">
    <ion-col size="1">
      <ion-icon name="checkmark-circle" class="green"></ion-icon>
    </ion-col>
    <ion-col size="7">
      <p class="green title">{{item.title}}</p>
        <p>{{item['itemsPerCase']}}</p>
      </ion-col>
      <ion-col size="2">
        <p class="green oh">{{item['OH']}}</p>
        <p>{{item['PL']}}</p>
      </ion-col>
      <ion-col size="2">{{item['D']}}</ion-col>
    </ion-row>
  }
</ion-grid>
